import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api';

function initialState () {
  return {

  };
}

const state = initialState ();

// actions

const actions = {
  async listEventBookings (context, payload) {
    var response = await API.booking.listEventBookings (payload);
    return response;
  },
  async get (context, payload) {
    var response = await API.booking.get (payload);
    return response;
  },
  async bookSeats (context, payload) {
    var response = await API.booking.bookSeats (payload);
    return response;
  },

  async cancelBooking (context, payload) {
    var response = await API.booking.cancelBooking (payload);
    context.commit ('monetization/update_purchase', response, DEFINES.USE_ROOT);
    return response;
  }
};

// getters
const getters = {
  getField
};

// mutations
const mutations = {
  updateField,
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
